namespace $.$$ {
	export class $shm_hitalama_guide_toggle extends $.$shm_hitalama_guide_toggle {
		checked( next?: boolean ) {
			if( next !== undefined ) this.$.$mol_state_arg.dict({ ...this.$.$mol_state_arg.dict(), help: next ? this.section() : 'off', help_page: null })
			return this.$.$mol_state_arg.value( 'help' ) === this.section()
		}
	}
}
